import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=61b0bf77&scoped=true"
import script from "./Logo.vue?vue&type=script&lang=js"
export * from "./Logo.vue?vue&type=script&lang=js"
import style0 from "./Logo.vue?vue&type=style&index=0&id=61b0bf77&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b0bf77",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\androidcode\\zf_tms_vue\\tms_vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61b0bf77')) {
      api.createRecord('61b0bf77', component.options)
    } else {
      api.reload('61b0bf77', component.options)
    }
    module.hot.accept("./Logo.vue?vue&type=template&id=61b0bf77&scoped=true", function () {
      api.rerender('61b0bf77', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/classic/sidebar/Logo.vue"
export default component.exports